//react
import React from 'react';

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TeacherCreated, TeacherUpdated } from 'redux/actions';

//firebase
import { db, storage } from 'assets/firebase';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";
//import styles from "assets/jss/material-kit-react/customCheckboxRadioSwitch.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import IconButton from "@material-ui/core/IconButton";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import CustomSelect from "components/Select/Select.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import PhotoCard from "components/PhotoCard/PhotoCard.jsx";

// @material-ui/icons
import Edit from "@material-ui/icons/Edit";
import Teacher from "@material-ui/icons/AssignmentInd";
import Photos from "@material-ui/icons/PhotoCameraOutlined";

//fileUploader
import FileUploader from 'react-firebase-file-uploader';

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

//unique id generator
const uuidv4 = require('uuid/v4');

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class TeacherEditor extends React.Component {

    constructor(props) {
      super(props);

      this.state = {
        modal: false,
        teacher: props.teacher
      };

      if(!this.state.teacher.UserType)
        this.state.teacher.UserType = "";

      this.saveTeacher = this.saveTeacher.bind(this);
      this.updateTeacher = this.updateTeacher.bind(this);

      this.deletePhoto = this.deletePhoto.bind(this);
      this.updatePhoto = this.updatePhoto.bind(this);
      this.makeCoverPhoto = this.makeCoverPhoto.bind(this);
      this.makeThumbPhoto = this.makeThumbPhoto.bind(this);
    }
    
    handleClickOpen(modal) {
      
      this.updateTeacher('SchoolID',this.props.schoolID);
      
      var x = [];
      x[modal] = true;
      this.setState(x);
    }

    handleClose(modal) {
      var x = [];
      x[modal] = false;
      this.setState(x);
    }

    updateTeacher(property, value) {
      var teacher = this.state.teacher;
      teacher[property] = value;
      this.setState({teacher});
    }

    addPhoto(url) {

      var teacher = this.state.teacher;
      if(!teacher.Photos) {
        teacher.Photos = [];
      }

      var photo = { ID: uuidv4(), Name: "New Photo", Description: "description", URL: url, Attribution:"", License:"", isCover: false, isThumb: false};

      teacher.Photos.push(photo);
      this.setState({teacher});
    }

    updatePhoto(photo) {
      var teacher = this.state.teacher;
      
      for(var i = 0; i < teacher.Photos.length; i++) {
        if(teacher.Photos[i].ID === photo.ID) {
          teacher.Photos[i] = photo;
          break;
        }
      }
    }

    deletePhoto(photo) {
      var teacher = this.state.teacher;

      for(var i = teacher.Photos.length - 1; i > -1; i--) {
        if(teacher.Photos[i].ID === photo.ID) {
          teacher.Photos.splice(i,1);
          break;
        }
      }

      this.setState({teacher});
    }

    makeCoverPhoto(photo) {
      var teacher = this.state.teacher;
      
      for(var i = 0; i < teacher.Photos.length; i++) {
        if(teacher.Photos[i].ID === photo.ID) {
          teacher.Photos[i].isCover = true;
        } else {
          teacher.Photos[i].isCover = false;
        }
      }
    }

    makeThumbPhoto(photo) {
      var teacher = this.state.teacher;
      
      for(var i = 0; i < teacher.Photos.length; i++) {
        if(teacher.Photos[i].ID === photo.ID) {
          teacher.Photos[i].isThumb = true;
        } else {
          teacher.Photos[i].isThumb = false;
        }
      }
    }

    showPasswordPrompt() {
      if(this.state.teacher.id) {
        return "none";
      } else {
        return "block";
      }
    }

    saveTeacher() {
      
      var teacher = this.state.teacher;
      if(!teacher.id)
        teacher.id = uuidv4();

      db.updateUser(teacher.id, teacher).then(doc => {
        
        var data = {
          "name": teacher.FirstName + ' ' + teacher.LastName,
          "company_id": teacher.SchoolID,
          "email": teacher.EmailAddress,
          "user_id": teacher.id,
          "user_type": teacher.UserType
        }

        fetch("https://us-central1-keiki-262db.cloudfunctions.net/upsertUser", {
          method: "POST", 
          cache: "no-cache",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        })
        .then((response) => {
            if(response.ok) {
                return response.json()
            } else {
              console.log("save school to intercom error1");  
              console.log(response);
            }
        })
        .then((json) => {
          
          if(json) {  

            if(this.props.newUser) { // i.e. if it's a new teacher
    
              this.props.onTeacherCreated(this.state.teacher);
    
              ReactGA.event({
                category: 'Teacher',
                action: 'Created a New Teacher'
              });
    
              // reset to blank
              this.setState({teacher:{
                FirstName: "",
                LastName: "",
                EmailAddress: "",
                Password: "",
                UserName: "",
                Photos: [],
                UserType: this.props.userType,
                SchoolID: this.props.schoolID,
                orgId: this.props.org.id
              }});
    
            } else { // i.e. an existing teacher
    
              this.props.onTeacherUpdated(this.state.teacher);
              ReactGA.event({
                category: 'Teacher',
                action: 'Updated a Teacher'
              });
            }
    
            this.props.onChange();
          }
        })
        .catch((error) => {
          // If there is any error you will catch them here
          console.log("error saving user to intercom: " + error);
        });
      });
    }
        
    // photos
    photoUploadStart = () => this.setState({isUploading: true, progress: 0});
    photoUploadProgress = (progress) => this.setState({progress});
    photoUploadError = (error) => {
        this.setState({isUploading: false});
        console.error(error);
    }
    photoUploadSuccess = (filename) => {
        this.setState({progress: 100, isUploading: false});
        
        storage.images.child(filename).getDownloadURL().then(url => this.addPhoto(url));
    };


    trim(value, maxLength) {
      if(value.length > maxLength)
          return value.substring(0,maxLength) + "...";
      else
          return value;
    }

    render() {

      const { classes } = this.props;

      return (
        <div>
          <IconButton
            aria-label="Edit"
            onClick={() => this.handleClickOpen("modal")}>
            <Edit
                className={
                    classes.tableActionButtonIcon + " " + classes.edit
                }
            />
          </IconButton>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal
            }}
            open={this.state.modal}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => this.handleClose("modal")}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">

            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{backgroundColor:"#efefef"}} >

              <GridContainer direction="row">
                <GridItem xs={12} sm={12} md={6}>
                  <h4 className={classes.modalTitle}>Edit Teacher</h4>
                </GridItem>
                <GridItem xs={12} sm={12} md={6} style={{textAlign:"right"}}>
                  
                </GridItem>
              </GridContainer>
            </DialogTitle>
            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
              style={{backgroundColor:"#efefef"}}>
             <CustomTabs
                headerColor="success"
                tabs={[
                  {
                    tabName: "General",
                    tabIcon: Teacher,
                    tabContent: (
                      
                        <GridContainer direction="row">
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomInput
                              id="firstName"
                              labelText="First Name"
                              value={this.state.teacher.FirstName}
                              inputProps={{
                                  placeholder: "First Name"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateTeacher("FirstName", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomInput
                                id="lastName"
                                labelText="Last Name"
                                value={this.state.teacher.LastName}
                                inputProps={{
                                    placeholder: "Last Name"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateTeacher("LastName", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                                id="email"
                                labelText="Email Address"
                                value={this.state.teacher.EmailAddress}
                                inputProps={{
                                    placeholder: "Email Address"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateTeacher("EmailAddress", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomSelect
                                labelText="User Type"
                                value={this.state.teacher.UserType}
                                inputProps={{
                                    placeholder: "User Type"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateTeacher("UserType", e.target.value)}
                                options={[
                                  {key:"administrative",label:"Administrative"},
                                  {key:"admin",label:"ATEQ Admin"},
                                  {key:"assistant-principal",label:"Assistant Principal"},
                                  {key:"counselor",label:"Counselor"},
                                  {key:"nurse",label:"Nurse"},
                                  {key:"parent",label:"Parent"}, 
                                  {key:"principal",label:"Principal"},
                                  {key:"pta",label:"PTA"}, 
                                  {key:"teacher",label:"Teacher"},
                                ]}
                               />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6} style={{display:this.showPasswordPrompt()}}>
                            <CustomInput
                                id="password"
                                labelText="Initial Password"
                                value={this.state.teacher.Password}
                                inputProps={{
                                    placeholder: "Initial Password",
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateTeacher("Password", e.target.value)}
                            />
                          </GridItem>
                        </GridContainer>
                    )
                  },
                  {
                    tabName: "Photos",
                    tabIcon: Photos,
                    tabContent: (

                      <div>
                        <div style={{marginTop:"10px"}}>

                          <label style={{color: "#696969", cursor:"pointer"}}>
                            Upload a New Photo  
                          
                            <FileUploader
                              hidden 
                              accept="image/*"
                              name="photo"
                              randomizeFilename
                              storageRef={storage.images}
                              onUploadStart={this.photoUploadStart}
                              onUploadError={this.photoUploadError}
                              onUploadSuccess={this.photoUploadSuccess}
                              onProgress={this.photoUploadProgress}
                              />
                              
                          </label>
                        </div>

                        <GridContainer justify="flex-start">
                          {this.state.teacher.Photos.map(photo => (
                              <PhotoCard key={photo.id} photo={photo} 
                                onPhotoUpdated={this.updatePhoto} onPhotoMakeCover={this.makeCoverPhoto} 
                                onPhotoMakeThumb={this.makeThumbPhoto} onPhotoDelete={this.deletePhoto} />
                          ))}
                        </GridContainer>
                      </div>
                    )
                  }
                ]}
              />

            </DialogContent>
            
            <DialogActions
              className={classes.modalFooter }
              style={{backgroundColor:"#efefef"}}>
              <Button
                    onClick={() => this.handleClose("modal")}
                  >
                    Cancel
                  </Button>
                  &nbsp;
                  <Button
                    onClick={() => {
                        this.saveTeacher();
                        this.handleClose("modal");
                      }}
                    color="success">
                    Save
                  </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
}
  
const mapStateToProps = state => {
  return state;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({onTeacherCreated: TeacherCreated, onTeacherUpdated: TeacherUpdated }, dispatch);  
}

TeacherEditor = connect(mapStateToProps, mapDispatchToProps)(TeacherEditor);
export default withStyles(modalStyle)(TeacherEditor);


// WEBPACK FOOTER //
// ./src/components/TeacherEditor/TeacherEditor.jsx